/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import { handleUploadChange } from '../../helpers/imageUploadRemove';
import ErrorMessage from '../../components/ErrorMessageDisplay';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { cdnURL } from '../../config';
import FileLoader from '../../components/FileLoader';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import { dataService } from '../../services/data.service';
import ApplicationContext from '../../context/ApplicationContext';
import InsuranceHeader from './InsuranceHeader';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { insuranceLanguageContent } from './InsuranceLanguageContent';
import { identificationLanguageContent } from '../IdentityDocument/IdentificationLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function UploadInsurancePhoto(props) {
    const { handlePage, insuranceIndex, insurances, setLoading, sessionData, selectedLanguage } = useContext(ApplicationContext);
    const [frontFileName, setFrontFileName] = useState('');
    const [backFileName, setBackFileName] = useState('');
    const [insuranceFrontImage, setInsuranceFrontImage] = useState('');
    const [insuranceBackImage, setInsuranceBackImage] = useState('');
    const [frontImageError, setFrontImageError] = useState('');
    const [backImageError, setBackImageError] = useState('');
    const [frontImageLoading, setFrontImageLoading] = useState(false);
    const [backImageLoading, setBackImageLoading] = useState(false);
    const [frontTempImage, setFrontTempImage] = useState('');
    const [backTempImage, setBackTempImage] = useState('');
    const [loader, setLoader] = useState(false);
    const [insuranceId, setInsuranceId] = useState('');

    const handleUploadPhoto = (e, event) => {
        if(e.target.files) {
            if(event === 'front') {
                setFrontImageLoading(true);
                setFrontFileName(e.target.files[0].name)
                handleUploadChange(e, setFrontImageError, setFrontImageLoading, 0, 0, 5242880, '5MB', '', ['image/png', 'image/jpg', 'image/jpeg'], 'patients/insurance-upload', setFrontTempImage, setInsuranceFrontImage, false, '')
            } else {
                setBackImageLoading(true);
                setBackFileName(e.target.files[0].name)
                handleUploadChange(e, setBackImageError, setBackImageLoading, 0, 0, 5242880, '5MB', '', ['image/png', 'image/jpg', 'image/jpeg'], 'patients/insurance-upload', setBackTempImage, setInsuranceBackImage, false, '')
            }
        }
    }

    const handleSubmitImage = async() => {
        setLoader(true);
        let payload = {
            "insurance_front_image": insuranceFrontImage,
            "insurance_back_image": insuranceBackImage,
            "upload_type_front": "upload",
            "upload_type_back": "upload",
            "process_ocr": false
        }
        if(insuranceId) {
            if(insurances[insuranceIndex] && insurances[insuranceIndex].process_ocr === false) {
                // do nothing
            } else if(insurances[insuranceIndex].insurance_front_image !== insuranceFrontImage || insurances[insuranceIndex].insurance_back_image !== insuranceBackImage || insurances[insuranceIndex].carrier === '') {
                payload = {
                    ...payload,
                    "process_ocr": true
                }
            }
            dataService.updateInsuranceData(sessionStorage.getItem('session'), payload, insuranceId).then((res) => {
                if(res.error === false) {
                    setLoader(false);
                    setLoading(true);
                    handlePage('insurance_details', 'upload_insurance_images',`${insuranceIndex}`, sessionData['review'] === 'previous' ? 'previous' : '');
                }
            });
        } else {
            payload = {
                ...payload,
                "process_ocr": true
            }
            dataService.addInsuranceData(sessionStorage.getItem('session'), payload).then((res) => {
                if(res.error === false) {
                    setLoader(false);
                    setLoading(true);
                    handlePage('insurance_details', 'upload_insurance_images', `${insuranceIndex || 0}`, sessionData['review'] === 'previous' ? 'previous' : '');
                }
            });
        }
    }

    const handleBackNavigation = () => {
        handlePage('upload_insurance_choice', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
    }

    useEffect(() => {
        if(insurances.length > 0) {
            if(insurances[insuranceIndex] && insurances[insuranceIndex].upload_type_front === "upload") {
                setFrontTempImage(`https://${cdnURL}/${insurances[insuranceIndex].insurance_front_image}`);
                setBackTempImage(`https://${cdnURL}/${insurances[insuranceIndex].insurance_back_image}`)
                setInsuranceFrontImage(insurances[insuranceIndex].insurance_front_image);
                setInsuranceBackImage(insurances[insuranceIndex].insurance_back_image);
                setInsuranceId(insurances[insuranceIndex]._id);
                setFrontFileName((insurances[insuranceIndex].insurance_front_image).split('/')[2]);
                setBackFileName((insurances[insuranceIndex].insurance_back_image).split('/')[2])
            } else {
                if(insurances[insuranceIndex]) {
                    setInsuranceId(insurances[insuranceIndex]._id);
                }
            }
        }
    }, [insurances]);

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-auto'>
            <InsuranceHeader />
            <div className='p-[8px] overflow-x-hidden overflow-y-auto options-height Enterprise-scroll mt-[18px]'>
                <div className='mx-[12px] '>
                    <div>
                        {insuranceLanguageContent['insurance-front-upload'][selectedLanguage]}  
                        <div className={`mt-[32px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                            <p className='text-sm font-normal text-[#333]'>{insuranceLanguageContent['insurance'][selectedLanguage]}<b className='text-primary'> {insuranceLanguageContent['front'][selectedLanguage]}</b></p>
                            <div className={`mt-1 relative border ${frontImageError === '' ? 'border-[#797979]' : 'border-[#B51803]'} rounded h-[40px] flex justify-between`}>
                                <p className='py-[10px] px-[12px] text-sm text-[#333] font-normal text-truncate'>{insuranceFrontImage === '' ? '' : frontFileName}</p>
                                <button className='bg-[#D7D7D7] p-[8px] text-[#797979] font-semibold w-fit'>
                                    {identificationLanguageContent['browse'][selectedLanguage]}
                                </button>
                                <input data-testid="browse_file_front" accept='.png, .jpeg, .jpg' type='file' className={`h-[39px] absolute w-[77px] ${selectedLanguage === 'ar' ? 'left-[15px]' : 'right-[13px]'} opacity-0`} 
                                    onChange={(e) => {setInsuranceFrontImage(''); handleUploadPhoto(e, 'front')}} />
                            </div>
                            {frontImageError && <ErrorMessage text={frontImageError} />}
                            <p className='text-[#797979] font-normal text-sm mt-1'>{identificationLanguageContent['file-format'][selectedLanguage]}</p>
                            {insuranceFrontImage !== '' && <div className='mt-[42px] mx-[20px] flex justify-center h-[174px]'>
                                <AnimatedImage url={frontTempImage} alt="id-card" />
                            </div>}
                            {frontImageLoading &&
                            <div className='mt-[60px] mx-[20px] flex justify-center h-[174px]'>
                                <FileLoader />
                            </div>}
                        </div>
                    </div>
                    <div className={`mt-[48px] pb-4 ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                        {insuranceLanguageContent['insurance-back-upload'][selectedLanguage]}
                        <div className='mt-[32px] mb-4'>
                            <p className='text-sm font-normal text-[#333]'>{insuranceLanguageContent['insurance'][selectedLanguage]}<b className='text-primary uppercase'> {backNextLanguageContent['back'][selectedLanguage]}</b></p>
                            <div className={`mt-1 relative border ${backImageError === '' ? 'border-[#797979]' : 'border-[#B51803]'} rounded h-[40px] flex justify-between`}>
                                <p className='py-[10px] px-[12px] text-sm text-[#333] font-normal text-truncate'>{insuranceBackImage === '' ? '' : backFileName}</p>
                                <button className='bg-[#D7D7D7] p-[8px] text-[#797979] font-semibold w-fit'>
                                    {identificationLanguageContent['browse'][selectedLanguage]}
                                </button>
                                <input data-testid="browse_file_back" accept='.png, .jpeg, .jpg' type='file' className={`h-[39px] absolute w-[77px] ${selectedLanguage === 'ar' ? 'left-[15px]' : 'right-[13px]'} opacity-0`} 
                                    onChange={(e) => {setInsuranceBackImage(''); handleUploadPhoto(e, 'back')}} />
                            </div>
                            {backImageError && <ErrorMessage text={backImageError} />}
                            <p className='text-[#797979] font-normal text-sm mt-1'>{identificationLanguageContent['file-format'][selectedLanguage]}</p>
                            {insuranceBackImage !== '' && <div className='mt-[42px] mx-[20px] flex justify-center h-[174px]'>
                                <AnimatedImage url={backTempImage} alt="id-card" />
                            </div>}
                            {backImageLoading &&
                            <div className='mt-[60px] mx-[20px] flex justify-center h-[174px]'>
                                <FileLoader />
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap gap-[12px] '>
                <BackButton disabled={loader || frontImageLoading || backImageLoading} handleClick={() => handleBackNavigation()} backType="previous" />
                <NextButton disabled={insuranceFrontImage === '' || insuranceBackImage === '' || loader} handleClick={() => handleSubmitImage()} loader={loader} />
            </div>
        </AnimatedPageFade>
    );
}

export default UploadInsurancePhoto;